import { render, staticRenderFns } from "./CameraRessource.vue?vue&type=template&id=6465a4da"
import script from "./CameraRessource.vue?vue&type=script&lang=js"
export * from "./CameraRessource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports